import React, {Component} from 'react';


class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <div className="row mb-2">
                    <div className="col-3 text-left" style={{paddingTop: '5px'}}>

                    </div>
                    <div className="col-3">

                    </div>
                    <div className="col-3 text-right">

                    </div>
                    <div className="col-3 text-right">
                        {/*<b>Network:</b> Mainnet*/}
                    </div>
                </div>
                <nav className="navbar navbar-expand-lg navbar-dark rounded" style={{backgroundColor: '#282828'}}>
                    <a className="navbar-brand" href="/" style={{fontSize: '24px'}}>
                        <img src="/p3x-exchange/images/p3x.png" style={{width: '50px'}} alt="P3X Logo"/>
                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample09" aria-controls="navbarsExample09" aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarsExample09">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <a className="nav-link active" href="https://powh3d.hostedwiki.co/pages/What%20is%20P3X" target="_blank" rel="noreferrer noopener">P3X Wiki</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link active" href="https://discordapp.com/invite/wfG97Kt" target="_blank" rel="noreferrer noopener">Community Chat</a>
                            </li>
                            <li className="nav-item dropdown mr-auto">
                                <div className="nav-link active dropdown-toggle" id="dropdown03" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{cursor: 'pointer'}}>Smart
                                    Contracts
                                </div>
                                <div className="dropdown-menu" aria-labelledby="dropdown03">
                                    <a className="dropdown-item" href={this.props.data.P3DTokenContractEtherscan} target="_blank" rel="noreferrer noopener">POWH3D Original</a>
                                    <a className="dropdown-item" href={this.props.data.P3XTokenContractEtherscan} target="_blank" rel="noreferrer noopener">POWH3D Extended</a>
                                </div>
                            </li>
                        </ul>
                        <a className="nav-link" href="https://curvy.ai/minnow" style={{color:'white'}} target="_blank">By minnow with ❤️</a>
                        <ul className="navbar-nav">
                            {/*<li className="nav-item dropdown">*/}
                            {/*<div className="nav-link dropdown-toggle" id="dropdown03" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{cursor: 'pointer'}}>*/}
                            {/*Language*/}
                            {/*</div>*/}
                            {/*<div className="dropdown-menu">*/}
                            {/*<div className="dropdown-item" data-language="eng" onClick={this.props.languageChange}>English</div>*/}
                            {/*<div className="dropdown-item" data-language="esp" onClick={this.props.languageChange}>Espanol</div>*/}
                            {/*<div className="dropdown-item" data-language="chn" onClick={this.props.languageChange}>Chinese</div>*/}
                            {/*</div>*/}
                            {/*</li>*/}
                            <li className="nav-item dropdown">
                                <div className="nav-link active dropdown-toggle" id="dropdown03" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                     style={{cursor: 'pointer'}}>Currency
                                </div>
                                <div className="dropdown-menu">
                                    <div className="dropdown-item" data-currency="USD" onClick={this.props.currencyChange}>USD</div>
                                    <div className="dropdown-item" data-currency="CAD" onClick={this.props.currencyChange}>CAD</div>
                                    <div className="dropdown-item" data-currency="EUR" onClick={this.props.currencyChange}>EUR</div>
                                    <div className="dropdown-item" data-currency="GBP" onClick={this.props.currencyChange}>GBP</div>
                                    <div className="dropdown-item" data-currency="JPY" onClick={this.props.currencyChange}>JPY</div>
                                    <div className="dropdown-item" data-currency="BTC" onClick={this.props.currencyChange}>BTC</div>
                                    <div className="dropdown-item" data-currency="XMR" onClick={this.props.currencyChange}>XMR</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </React.Fragment>
        );
    }
}

export default Menu;